export default __webpack_public_path__ + "static/huiliang-4192b98da4ee89412ba49a030463eaa5.jpg";